var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTriangleExclamation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10799_9206)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10799_9206)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_10799_9206)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 3.5,
    width: 2,
    height: 10,
    fill: "#F3F3F5"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M6.99239 14.498C5.38784 14.498 3.7833 14.5026 2.17875 14.498C1.31439 14.4941 0.654782 14.0801 0.25225 13.2295C-0.0752864 12.5377 -0.0913318 11.8108 0.248064 11.127C0.82012 9.9743 1.43054 8.84579 2.02353 7.70883C3.07137 5.70652 4.12037 3.70485 5.17053 1.70382C5.82037 0.47076 7.15877 0.13482 8.2244 0.930081C8.54043 1.1657 8.75076 1.50202 8.93842 1.86026C10.5197 4.88397 12.1032 7.90588 13.6889 10.926C14.3381 12.1644 13.9401 13.647 12.7855 14.2727C12.5133 14.421 12.2136 14.4977 11.91 14.4968C10.2705 14.4968 8.63112 14.4968 6.99169 14.4968L6.99239 14.498ZM7.76501 5.64515C7.76501 5.57481 7.76955 5.50408 7.76501 5.43413C7.72281 4.84835 7.17203 4.48281 6.6952 4.73304C6.41615 4.87833 6.26162 5.13393 6.24837 5.47718C6.22918 5.97686 6.29964 6.47231 6.32336 6.97007C6.36266 7.79979 6.40731 8.62939 6.45731 9.45886C6.48068 9.84323 6.70741 10.0739 7.02832 10.0631C7.34225 10.0531 7.55154 9.79403 7.56584 9.4162C7.57514 9.12869 7.58805 8.84131 7.60456 8.55406C7.65967 7.58468 7.69106 6.61337 7.76501 5.64515ZM7.74199 11.5533C7.7392 11.0655 7.43434 10.7246 7.00355 10.7277C6.90479 10.7267 6.80684 10.7474 6.71543 10.7886C6.62402 10.8298 6.54098 10.8907 6.47116 10.9677C6.40134 11.0446 6.34614 11.1362 6.30878 11.2369C6.27143 11.3377 6.25267 11.4456 6.2536 11.5544C6.25639 11.9876 6.60555 12.3659 7.00529 12.3689C7.10261 12.37 7.19913 12.3496 7.28919 12.309C7.37925 12.2683 7.46101 12.2082 7.52966 12.1322C7.59831 12.0562 7.65246 11.9658 7.68893 11.8664C7.7254 11.767 7.74344 11.6605 7.74199 11.5533Z",
    fill: "#FC5555"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10799_9206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10799_9206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_10799_9206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.8333,
    height: 12.8333,
    fill: "white",
    transform: "translate(0.583496 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleExclamation);
export default __webpack_public_path__ + "static/media/triangle-exclamation.c190706ca0f2c71ababce177666ba5d3.svg";
export { ForwardRef as ReactComponent };